<template>
	<path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
		stroke-linejoin="round" />
</template>
